// extracted by css-extract-rspack-plugin
export default {"MainContent":"ArtifactRegistryShow-module__MainContent__Woe4j","Sidebar":"ArtifactRegistryShow-module__Sidebar__DAkBM"};